module.exports = new __parcel__URL__("target-single-darkmode.5d8fc324.svg").toString();